import Toast from "../../components/toast/Toast";
import BACKEND from "../api/backend";
import XTREAM from "../api/xtream";
import Storege from "../storage/storage";
import storeSubscribe from "../store/subscribe";
import PlaylistStorage from "../playlists";
import { ParseChannelsContent, ParseMoviesContent } from "./parser";
import { emptyContent } from "./emptyContent";

const [setChannelsContent] = storeSubscribe("channelsContent", (channelsContent) => { });

const [setMoviesContent] = storeSubscribe("moviesContent", (moviesContent) => { });

const [setSeriesContent] = storeSubscribe("seriesContent", (seriesContent) => { });

const [setStreamFormats] = storeSubscribe("streamFormats", (streamFormats) => { });

const [setPlaylistInfo] = storeSubscribe("playlistInfo", (playlistInfo) => { });



let playlistData = {
    channels: [],
    movies: [],
    series: []
}

let retryCount = 3;
let retryTimeMS = 3000;

let xtreamLoginRetryTimeout = null;
let channelsRetryTimeout = null;
let moviesRetryTimeout = null;
let seriesRetryTimeout = null;


// get channels
export const GetPlaylistChannels = async (playlist) => {

    return new Promise((resolve, reject) => {

        clearTimeout(channelsRetryTimeout);

        let xtream_account = XTREAM.isXtreamPlaylist(playlist.url);

        if (xtream_account) {

            const getXtreamChannels = async (retry) => {

                try {

                    let channels = await XTREAM.getChannels();
                    let categories = await XTREAM.getChannelCategories();
                    let payload = await ParseChannelsContent(channels, categories, true);

                    playlistData.channels = payload;

                    setChannelsContent({ ...payload, status: "success" });
                    resolve('success')

                } catch (e) {

                    console.log(e);

                    if (retry < retryCount) {

                        console.log("channels retry", retry);

                        channelsRetryTimeout = setTimeout(() => {
                            getXtreamChannels(retry + 1);
                        }, retryTimeMS);

                    } else {
                        setChannelsContent({ ...emptyContent, status: "error" });
                        reject('error')
                    }

                }

            }

            getXtreamChannels(0);

        } else {

            // only Xtream playlists can be played
            setChannelsContent({ ...emptyContent, status: "error" });
            reject('error')

        }
    })



}

// get movies
export const GetPlaylistMovies = async (playlist) => {


    return new Promise((resolve, reject) => {

        clearTimeout(moviesRetryTimeout);

        let xtream_account = XTREAM.isXtreamPlaylist(playlist.url);

        if (xtream_account) {

            const getXtreamMovies = async (retry) => {

                try {

                    let movies = await XTREAM.getMovies();

                    let categories = await XTREAM.getMovieCategories();

                    movies.sort((a, b) => {
                        return a.added > b.added ? -1 : 1;
                    });

                    // movies, categories, isSeries, isXtream
                    let payload = await ParseMoviesContent(movies, categories, false, true);

                    playlistData.movies = payload;

                    setMoviesContent({ ...payload, status: "success" });

                    resolve('success')

                } catch (e) {

                    console.log(e);

                    if (retry < retryCount) {

                        console.log("movies retry", retry);

                        moviesRetryTimeout = setTimeout(() => {
                            getXtreamMovies(retry + 1);
                        }, retryTimeMS);

                    } else {
                        setMoviesContent({ ...emptyContent, status: "error" });
                        reject('error')
                    }

                }

            }

            getXtreamMovies(0);

        } else {

            // only Xtream playlists can be played
            setMoviesContent({ ...emptyContent, status: "error" });
            reject('error')

        }

    })




}

// get series
export const GetPlaylistSeries = (playlist) => {


    return new Promise((resolve, reject) => {

        clearTimeout(seriesRetryTimeout);

        let xtream_account = XTREAM.isXtreamPlaylist(playlist.url);

        if (xtream_account) {

            const getXtreamSeries = async (retry) => {

                try {

                    let series = await XTREAM.getSeries();

                    let categories = await XTREAM.getSeriesCategories();

                    series.sort((a, b) => {
                        return a.last_modified > b.last_modified ? -1 : 1;
                    });

                    // movies, categories, isSeries, isXtream
                    let payload = await ParseMoviesContent(series, categories, true, true);

                    playlistData.series = payload;

                    setSeriesContent({ ...payload, status: "success" });

                    resolve('success')

                } catch (e) {

                    console.log(e);

                    if (retry < retryCount) {

                        console.log("series retry", retry);

                        seriesRetryTimeout = setTimeout(() => {
                            getXtreamSeries(retry + 1);
                        }, retryTimeMS);

                    } else {
                        setSeriesContent({ ...emptyContent, status: "error" });
                        reject('error')
                    }

                }

            }

            getXtreamSeries(0);

        } else {

            // only Xtream playlists can be played
            setSeriesContent({ ...emptyContent, status: "error" });
            reject('error')

        }

    })
}

// Only Xtream playlists can be played. A non-Xtream one (imported from the backend or the old local list)
// stays in the list but is never selected or loaded.
export const IsPlayablePlaylist = (playlist) => !!playlist && !!XTREAM.isXtreamPlaylist(playlist.url);

// The playlist to load at startup: the selected one, else the first playable one in list order.
// A selected playlist that can't be played loses its selection first.
export const GetStartupPlaylist = async (playlists) => {

    let selected = playlists.find((p) => p.is_selected);

    if (selected && !IsPlayablePlaylist(selected)) {
        await PlaylistStorage.clearSelection();
        selected = null;
    }

    return selected || playlists.find(IsPlayablePlaylist) || null;

}

export const GetPlaylistContent = async (playlist) => {

    // nothing is loaded or requested for a playlist that can't be played
    if (!IsPlayablePlaylist(playlist)) return 'error';

    XTREAM.abortAll();
    XTREAM.resetInfo();
    BACKEND.abortAll();
    setStreamFormats([]);

    setChannelsContent({ ...emptyContent, status: "loading" });
    setMoviesContent({ ...emptyContent, status: "loading" });
    setSeriesContent({ ...emptyContent, status: "loading" });

    clearTimeout(xtreamLoginRetryTimeout);


       const result = await initXtreamPlaylist(playlist)

       if(result == 'errorLogout'){
              return 'errorLogout';
       }

    // the account logged in: it becomes the selected playlist (no-op when it already is)
    if (!playlist.is_selected) await PlaylistStorage.select(playlist.id);

    try {

        await GetPlaylistData(playlist);


        return 'success'


    } catch (e) {


        return 'error'
    }

}

export const initXtreamPlaylist = async (playlist) => {

    let xtream_account = XTREAM.isXtreamPlaylist(playlist.url);
    
        try {

            const xtream_login = async () => {

                return new Promise((resolve, reject) => {

                    const login = async (retry) => {

                        try {

                            let account = await XTREAM.login(xtream_account);

                            resolve(account);

                        } catch (msg) {

                            if (msg == 'errorLogout') {

                                if (playlist.id) {

                                    await PlaylistStorage.remove(playlist.id);

                                }

                            }

                            reject(msg)

                        }

                    };

                    login(0);

                });

            };

            var account = await xtream_login();

            setPlaylistInfo(account?.user_info);

            if (playlist.id) {

                let exp_date = account?.user_info?.exp_date || null;

                let is_trial = account?.user_info?.is_trial == "1";                

                addDeviceActiveRequest({

                    exp_date: parseInt(exp_date),

                    playlist_id: playlist.id,

                    is_trial,

                });

            }


        } catch (msg) {
            console.log(msg);
            
            setChannelsContent({ ...emptyContent, status: "error" });
            setMoviesContent({ ...emptyContent, status: "error" });
            setSeriesContent({ ...emptyContent, status: "error" });


            return "errorLogout"

        }

        if (account?.user_info?.allowed_output_formats) {

            let formats = account.user_info.allowed_output_formats;

            if (Array.isArray(formats) && formats.length > 0) {
                setStreamFormats(formats);
            }

        }


        XTREAM.init(xtream_account, account);
        XTREAM.stream_format = Storege.getSteamFormat();

        return 'success';
}


const GetPlaylistData = async (playlist) => {

    let count = 0;
    return new Promise((resolve, reject) => {

        GetPlaylistChannels(playlist).then((res) => {
            count++
            done()

        });

        GetPlaylistMovies(playlist).then((res) => {
            count++
            done()

        });

        GetPlaylistSeries(playlist).then((res) => {
            count++
            done()

        });


        const done = () => {


            if (count == 3) {

                resolve('success')

            }

        }

    })
}


export const addDeviceActiveRequest = async ({ exp_date = 0, is_trial = false, playlist_id } = {}) => {


    BACKEND.addActiveDevice({
        playlist_id,
        exp_date,
        is_trial,
    })
        .then((res) => {
            console.log(res);
        })
        .catch((e) => {
            console.log(e);
        });
}